import React, { useEffect, useState } from 'react';
import { CloseWhiteTransParent } from 'res/images';
import CommonToolTip from './CommonToolTip';
import { clickOnElmOnBodyClick, dateFormat } from './Helper';
import { useSelector } from 'react-redux';
import { ConstructionIcon } from 'lucide-react';

function FilterChips(props) {
  const { data, setData, clearData } = props;
  const [showFilterData, setShowFilterData] = useState({});
  const ignoreKeys = ['tag_ids', 'tags_data', 'admin_ids', 'category_ids', 'author_ids', 'patient_ids', 'active_patients'];
  const locations = useSelector((state) => state.sliceReducer.locations);
  const allDoctorsList = useSelector((state) => state.sliceReducer.allDoctorsList);
  const statusList = useSelector((state) => state.sliceReducer.statusList);
  const careManagerLeads = useSelector((state) => state?.sliceReducer?.careManagerLeads);

  useEffect(() => {
    itrateObject();
  }, [data]);

  const itrateObject = () => {
    let tmpData = {};
    Object.keys(data).map((item) => {
      if (!ignoreKeys.includes(item)) {
        tmpData[item] = data[item];
      }
    });
    setShowFilterData(tmpData);
  };

  let removeValueFromString = (string, removeStr, seprateBy) => {
    if (string && removeStr) {
      let arr = string.split(seprateBy);
      let newArr = [];
      arr.map((item) => {
        if (item != removeStr) {
          newArr.push(item);
        }
      });
      let newArrStr = newArr.join(seprateBy);
      return newArrStr;
    } else {
      return '';
    }
  };

  const handleStringData = (data, key) => {
    let dataArr = data?.split(',');
    if (key === 'care_pathway' && showFilterData?.exclude_prc) {
      let index = dataArr.indexOf('PRC');
      if (index > -1) {
        dataArr.splice(index, 1);
      }
    }
    return dataArr.map((item, index) => {
      if (item) {
        return (
          <div className='chips capitalize activeTagsStyle pointer' key={index}>
            {item}
            <CommonToolTip
              placement={'bottom'}
              item={<img onClick={() => removeStringData(data, item, key)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />}
              showValue={'Remove'}
            />
          </div>
        );
      }
    });
  };

  const handleInsuranceCat = (data, key) => {
    let dataArr = data?.split('|');
    return dataArr.map((item, index) => {
      if (item) {
        return (
          <div className='chips capitalize activeTagsStyle pointer' key={index}>
            {item}
            <CommonToolTip
              placement={'bottom'}
              item={<img onClick={() => removeStringData(data, item, key, '|')} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />}
              showValue={'Remove'}
            />
          </div>
        );
      }
    });
  };

  const removeStringData = (strData, str, key, seprateBy = ',') => {
    data[key] = removeValueFromString(strData, str, seprateBy);
    setData && setData({ ...data });
  };

  const handleItemClick = (itemData, key, index) => {
    let idremove = String(itemData.id);

    let findKey = key.split('_')[0] + '_';
    let objecItemKey = '';
    ignoreKeys.map((item) => {
      if (item.includes(findKey)) {
        objecItemKey = item;
      }
    });

    let tmpData = [...data[key]];
    tmpData.splice(index, 1);
    let newStr = removeValueFromString(data[objecItemKey], idremove);
    data[objecItemKey] = newStr;
    data[key] = tmpData;
    setData && setData({ ...data });
  };

  const itrateArr = (arr, keyStr, showKey = 'title') => {
    return arr?.map((item, index) => {
      return (
        <div className='chips capitalize activeTagsStyle pointer' key={index}>
          {item[showKey]}
          <img onClick={() => handleItemClick(item, keyStr, index)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />
        </div>
      );
    });
  };

  const itrateCMLArr = (arr, keyStr, showKey = 'title') => {
    return arr?.map((item, index) => {
      let displayName = careManagerLeads.find((CM) => CM?.id === item);
      return (
        <div className='chips capitalize activeTagsStyle pointer' key={index}>
          {displayName ? displayName?.full_name : ''}
          <img onClick={() => handleItemClick(item, keyStr, index)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />
        </div>
      );
    });
  };

  let removeDate = (key) => {
    data[key] = removeValueFromString(key, '');
    setData && setData({ ...data });
  };

  const itrateArrDate = (arr, keyStr) => {
    return (
      <div className='chips activeTagsStyle capitalize pointer'>
        {dateFormat(arr[0])} - {dateFormat(arr[1])}
        <CommonToolTip
          placement={'bottom'}
          item={<img onClick={() => removeDate(keyStr)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />}
          showValue={'Remove'}
        />
      </div>
    );
  };

  const itrateArrClinic = (keyStr, key) => {
    return keyStr?.map((item, index) => {
      let clinicObj = locations.find((items, i) => items.id == item);
      console.log(clinicObj);
      return (
        <div className='chips capitalize activeTagsStyle pointer' key={index}>
          {clinicObj?.title}
          <img onClick={() => handleItemClick(item, key, index)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />
          {/* <img onClick={() => removeStringData(clinicObj?.title, '', key)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} /> */}
        </div>
      );
    });

    // let clinicObj = locations.find((item, index) => item.id == keyStr);
    // return (
    //   <div className='chips activeTagsStyle capitalize pointer'>
    //     {clinicObj?.title}
    //     <CommonToolTip
    //       placement={'bottom'}
    //       item={<img onClick={() => removeStringData(clinicObj?.title, '', key)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />}
    //       showValue={'Remove'}
    //     />
    //   </div>
    // );
  };

  const itrateArrDoctor = (keyStr, key) => {
    return keyStr?.map((item, index) => {
      let doctorObj = allDoctorsList.find((items, i) => items.id == item);
      console.log(doctorObj);
      return (
        <div className='chips capitalize activeTagsStyle pointer' key={index}>
          {doctorObj?.title}
          <img onClick={() => handleItemClick(item, key, index)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />
        </div>
      );
    });

    // let doctorObj = allDoctorsList?.find((item, index) => item?.id == keyStr);
    // return (
    //   <div className='chips activeTagsStyle capitalize pointer'>
    //     {doctorObj?.title}
    //     <CommonToolTip
    //       placement={'bottom'}
    //       item={<img onClick={() => removeStringData(doctorObj?.title, '', key)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />}
    //       showValue={'Remove'}
    //     />
    //   </div>
    // );
  };

  const itrateArrDoctorBilling = (keyStr, key) => {
    let doctorObj = allDoctorsList?.find((item, index) => item?.id == keyStr);
    return (
      <div className='chips activeTagsStyle capitalize pointer'>
        {doctorObj?.title}
        <CommonToolTip
          placement={'bottom'}
          item={<img onClick={() => removeStringData(doctorObj?.title, '', key)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />}
          showValue={'Remove'}
        />
      </div>
    );
  };

  const itrateArrStatus = (keyStr, key) => {
    let doctorObj = statusList?.find((item, index) => item?.id == keyStr);
    return (
      <div className='chips activeTagsStyle capitalize pointer'>
        {doctorObj?.title}
        <CommonToolTip
          placement={'bottom'}
          item={
            <img
              onClick={() => {
                removeStringData(doctorObj?.title, '', key);
                removeStringData(showFilterData?.sub_status, '', 'sub_status');
              }}
              src={CloseWhiteTransParent}
              style={{ width: '14px', height: '14px' }}
            />
          }
          showValue={'Remove'}
        />
      </div>
    );
  };

  const handleRemoveSubStatus = (value) => {
    const tempData = [...data['sub_status']];
    let index = tempData.indexOf(value);
    if (index > -1) {
      tempData.splice(index, 1);
      data['sub_status'] = tempData;
      setData && setData({ ...data });
    }
  };
  const itrateArrSubStatus = (data, key) => {
    return data?.map((item, index) => {
      let displayName = item;
      return (
        <div className='chips capitalize activeTagsStyle pointer' key={index}>
          {displayName ? displayName : ''}
          <img onClick={() => handleRemoveSubStatus(item)} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />
        </div>
      );
    });
  };
  const excludePRC = () => {
    return (
      <div className='chips capitalize activeTagsStyle pointer'>
        {'Exclude PRC'}
        <img onClick={() => setData((prev) => ({ ...prev, exclude_prc: false }))} src={CloseWhiteTransParent} style={{ width: '14px', height: '14px' }} />
      </div>
    );
  };
  const renderChipsTags = () => {
    let dataKeys = ['patient_data', 'author_data', 'admin_data'];
    let cMLKeys = ['care_manager_lead'];
    return Object.keys(showFilterData).map((item, index) => {
      if (dataKeys.includes(item)) {
        return itrateArr(showFilterData[item], item, 'full_name');
      } else if (cMLKeys?.includes(item)) {
        return itrateCMLArr(showFilterData[item], item, 'full_name');
      }
      if (item == 'clinic' && showFilterData[item].length > 0) {
        return itrateArrClinic(showFilterData[item], item);
      } else if (item == 'date' && showFilterData[item].length > 0) {
        return itrateArrDate(showFilterData[item], item);
      } else if (item == 'pmsDate' && showFilterData[item].length > 0) {
        return itrateArrDate(showFilterData[item], item);
      } else if (item == 'prescriptionDate' && showFilterData[item].length > 0) {
        return itrateArrDate(showFilterData[item], item);
      } else if (item == 'pmsConsultDate' && showFilterData[item].length > 0) {
        return itrateArrDate(showFilterData[item], item);
      } else if (item == 'prcDate' && showFilterData[item].length > 0) {
        return itrateArrDate(showFilterData[item], item);
      } else if (item == 'potentialPrcDate' && showFilterData[item].length > 0) {
        return itrateArrDate(showFilterData[item], item);
      } else if (item == 'insurance_category' && showFilterData[item].length > 0) {
        return handleInsuranceCat(showFilterData[item], item);
      } else if (item == 'doctor' && showFilterData[item]?.length > 0) {
        return itrateArrDoctor(showFilterData[item], item);
      } else if (item == 'doctor_id' && showFilterData[item]?.length > 0) {
        return itrateArrDoctorBilling(showFilterData[item], item);
      } else if (item == 'status' && showFilterData[item]?.length > 0) {
        return itrateArrStatus(showFilterData[item], item);
      } else if (typeof showFilterData[item] == 'string' && typeof showFilterData[item]) {
        return handleStringData(showFilterData[item], item);
      } else if (item == 'sub_status' && showFilterData[item]?.length > 0) {
        return itrateArrSubStatus(showFilterData[item], item);
      } else if (item == 'exclude_prc') {
        return showFilterData[item] ? excludePRC() : null;
      } else {
        return itrateArr(showFilterData[item], item);
      }
    });
  };
  return (
    <div>
      {Object.keys(showFilterData).length > 0 && (
        <div className='chipsTagsView' style={{ maxHeight: '15vh', overflow: 'scroll', border: '1px solid #e0e0e0', padding: '12px' }}>
          {renderChipsTags()}
          <div
            className='chips theme-border'
            onClick={(e) => {
              e.stopPropagation();
              clearData();
              clickOnElmOnBodyClick('datePickerContainer', 'rs-picker-toggle-clean', 'class');
            }}
          >
            Clear All
          </div>
        </div>
      )}
    </div>
  );
}

export default FilterChips;
